import { TabSwitch, VStack } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import React, { useState } from 'react';

import { CustomerDetailTypes } from '../..';

import { ContractedProducts } from './components/ContractedProducts';
import { GenialLimit } from './components/GenialLimit';

export const ProductsAndServices: React.FC<CustomerDetailTypes.Props> = () => {
  const isMobile = useBreakpointValue({
    base: true,
    sm: false,
  });

  const tabs = [
    {
      key: 'contractedProducts',
      label: 'Produtos Contratados',
      component: <ContractedProducts />,
    },
    {
      key: 'genialLimit',
      label: 'Limite Genial',
      component: <GenialLimit />,
    },
  ];

  const [selectedTab, setSelectedTab] = useState(tabs[0].key);

  return (
    <VStack flex={1}>
      <TabSwitch
        testId="tab-switch"
        tabs={tabs}
        selectedTab={selectedTab}
        onTabPress={setSelectedTab}
        isMobile={isMobile}
        isLoading={false}
      />
    </VStack>
  );
};
